import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { GridWrapper, Banner, FromTopPage } from "../theme";
import VerticalShareBar from "../components/VerticalShareBar";
import Dropdown from "../components/Dropdown";

const Container = styled(GridWrapper)`
  > h1 {
    color: black;
    font-size: 4.2rem;
    font-weight: 100;
    letter-spacing: -0.04rem;
    line-height: 4.6rem;
    margin: 65px 0 60px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      margin: 45px 0 40px;
    }
  }
`;

const Content = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;

  @media (max-width: 1023px) {
    margin-bottom: 30px;
  }

  > div {
    width: 1075px;

    @media (max-width: 1599px) {
      width: 800px;
    }

    @media (max-width: 1023px) {
      width: 516px;
    }
  }
`;

const Share = styled(VerticalShareBar)`
  margin-left: 16px;
  position: sticky;
  top: 120px;

  @media (max-width: 1023px) {
    margin-left: 8px;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

function FAQ() {
  return (
    <FromTopPage>
      <Banner>
        <GridWrapper>
          <h1>Questions récurrentes</h1>
        </GridWrapper>
      </Banner>
      <Container>
        <h1>Besoin d'aide&nbsp;? Votre question porte sur ...</h1>
        <Content>
          <Share text="Questions récurrentes" />
          <div>
            <Dropdown title="Où et comment regarder Le Média&nbsp;?">
              <p>
                Vous pouvez accéder librement aux productions du Média par
                différents canaux&nbsp;:
              </p>
              <ul>
                <li>
                  Le site internet du Média (<Link to="/direct">direct</Link>,{" "}
                  <Link to="/emissions">rediffusion</Link>,{" "}
                  <Link to="/articles">articles</Link>,{" "}
                  <Link to="/podcasts">podcasts</Link>)
                </li>
                <li>
                  La chaîne{" "}
                  <a
                    href="https://video.lemediatv.fr/c/chaine_officielle/videos"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PeerTube
                  </a>{" "}
                  du Média
                </li>
                <li>
                  La chaîne{" "}
                  <a
                    href="https://www.youtube.com/@LeMediaOfficiel"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    YouTube
                  </a>{" "}
                  du Média
                </li>
                <li>
                  Le compte{" "}
                  <a
                    href="https://twitter.com/LeMediaTV"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Twitter
                  </a>{" "}
                  du Média
                </li>
                <li>
                  Le compte{" "}
                  <a
                    href="https://www.instagram.com/lemedia_tv"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>{" "}
                  du Média
                </li>
                <li>
                  La page{" "}
                  <a
                    href="https://www.facebook.com/LeMediaOfficiel"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>{" "}
                  du Média
                </li>
              </ul>
            </Dropdown>
            <Dropdown title="Qu'est-ce qu'un Socio&nbsp;?">
              <p>
                Le Média est une coopérative, une SCIC (Société Coopérative à
                Intérêt Collectif). Les sociétaires de cette coopérative sont
                appelés les « Socios ». Le contenu du Média est visible par tous
                mais produire ces contenus n’est pas gratuit. Ainsi, les Socios
                contribuent via un abonnement (soit mensuel, soit annuel) à
                hauteur de leurs budgets et de leurs envies. Ceux-ci permettent
                au Média de rester indépendant vis-à-vis des puissances
                financières. Être Socio c’est être membre de la catégorie
                éponyme de la coopérative et donc{" "}
                <Link to="/soutien">
                  posséder au minimum cinq parts sociales de la coopératives
                </Link>
                .
              </p>
            </Dropdown>
            <Dropdown title="Devenir Socio&nbsp;?">
              <p>
                Pour devenir sociétaire du Média vous pouvez procéder de
                différentes manières mais il faudra nécessairement{" "}
                <Link to="/soutien">
                  créer un compte sur le&nbsp;site&nbsp;du&nbsp;Média
                </Link>
                .
              </p>
              <p>Deux étapes sont nécessaires :</p>
              <ul>
                <li>
                  Lors de la création de votre compte utilisateur il vous sera
                  proposé de procéder à l’acquisition de parts sociales. Un
                  minimum de cinq parts (1€ / unité) vous sera facturé une seule
                  fois, sans reconduction nécessaire. Vous pourrez vous
                  défausser de ces parts pour toute ou partie si vous le
                  souhaitez.
                </li>
                <li>
                  Une fois le nombre de parts indiqué, il vous sera demandé de
                  fixer le montant de l’abonnement que vous souhaitez contracter
                  auprès du Média. Cet abonnement est nécessaire vis à vis des{" "}
                  <Link to="/annexes/statuts">statuts de la SCIC</Link> pour
                  intégrer la catégorie des Socios. Cet abonnement peut être
                  mensuel (5 / 8 / 12 / 20 / 30 / 50€) ou annuel (60 / 96 / 144
                  / 360 / 600€).
                </li>
              </ul>
            </Dropdown>
            <Dropdown title="Comment régler mon abonnement ?">
              <p>
                Les abonnements au Média peuvent être réglés de différentes
                manières :
              </p>
              <ul>
                <li>
                  Prélèvement SEPA : une fois votre IBAN enregistré une demande
                  de création de mandat sera délivrée à votre banque, cette
                  procédure peut prendre deux à trois jours. Une fois cette
                  demande confirmée, le premier prélèvement de votre abonnement
                  sera effectué. Nous préférons ce mode de règlement pour des
                  questions de gestion des durée de validité des cartes.
                </li>
                <li>
                  Carte Bleue ou e-Carte Bleue : L’interface sécurisée du site
                  vous permettra de rentrer et de confirmer le paiement via le
                  code transmis par votre banque. Le règlement par prélèvement
                  via votre Carte Bleue nécessite simplement de mettre à jour ce
                  moyen de paiement une fois la Carte Bleue expirée.{" "}
                </li>
                <li>
                  Chèque : Il est possible de régler les abonnements annuels et
                  l’achat de parts sociales par l’envoi d’un chèque. Celui-ci
                  devra être transmis à l’adresse postale ci-dessous en
                  indiquant l’ordre suivant : <strong>SCIC Le Média</strong>.
                  Merci d’indiquer au dos l’adresse e-mail ayant servi à la
                  création de votre compte utilisateur.
                  <div style={{ margin: "20px 0", textAlign: "center" }}>
                    SCIC Le Média
                    <br />
                    242 Boulevard Voltaire
                    <br />
                    75011 Paris
                  </div>
                </li>
              </ul>
            </Dropdown>
            <Dropdown title="Faire un don au Média&nbsp;?">
              <p>
                Si vous souhaitez faire un don au Média, vous pouvez procéder de
                différentes manières&nbsp;:
              </p>
              <ul>
                <li>
                  Vous pouvez utiliser l’interface{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://dons.lemediatv.fr"
                  >
                    Donorbox
                  </a>{" "}
                  qui propose d’effectuer un don en passant par votre carte
                  bancaire. Ce don sera défiscalisé à hauteur de 66% de la somme
                  versée. Le reçu fiscal servant à la défiscalisation vous sera
                  transmis par J’aime l’Info, sur l’adresse indiquée sur
                  Donorbox, en principe durant le 1er trimestre de l’année
                  fiscale.
                </li>
                <li>
                  Vous pouvez procéder par chèque en nous faisant parvenir à
                  l’adresse ci-dessous une lettre comprenant le chèque et en
                  indiquant vos coordonnés. Ce chèque devra comporter l’ordre
                  suivant : <strong>SCIC Le Média / J’aime l’Info</strong> (nous
                  vous encourageons toutefois à privilégier le règlement par CB,
                  car 10€ seront déduits du montant du don par J’aime l’Info
                  pour traitement du chèque).
                  <div style={{ margin: "20px 0", textAlign: "center" }}>
                    SCIC Le Média
                    <br />
                    242 Boulevard Voltaire
                    <br />
                    75011 Paris
                  </div>
                  Ce chèque ne peut pas être simplement adressé à la SCIC Le
                  Média, devenu une entreprise nous ne pouvons pas accepter les
                  dons directs comme auparavant.
                </li>
              </ul>
            </Dropdown>
            <Dropdown title="Vous ne recevez pas les emails du Média&nbsp;?">
              <p>
                Les communications e-mails du Média sont diffusées selon deux
                bases&nbsp;:
              </p>
              <ul>
                <li>
                  Une base automatisée liée à votre abonnement (envoi de
                  facture, alerte suite à un échec de paiement, etc)
                </li>
                <li>
                  Une liste de diffusion qui nous permet de vous transmettre les
                  mails d’informations (Newsletter) liées à la vie du Média.
                </li>
              </ul>
              <p>
                Si vous ne recevez pas les e-mails du Média, merci de vérifier
                que&nbsp;:{" "}
              </p>
              <ul>
                <li>
                  Ceux-ci ne se trouvent pas dans le dossier « indésirable » de
                  votre boîte de messagerie.
                </li>
                <li>
                  L'adresse e-mail liée à votre compte utilisateur ne comporte
                  pas d’erreur.
                </li>
              </ul>
              <p>
                À noter que certaines messageries bloquent plus aisément les
                e-mails issus de communications perçues comme “commerciales”,
                exemple régulier : laposte.net.
              </p>
            </Dropdown>
            <Dropdown title="Nous quitter&nbsp;?">
              <p>
                Nous serions désolés de vous voir partir tant les projets de
                développement d’une autre information sont nombreux, mais si tel
                était le cas, vous pouvez utiliser le bouton de résiliation
                présent dans votre interface utilisateur pour rendre effective
                cette résiliation.
              </p>
            </Dropdown>
          </div>
        </Content>
      </Container>
    </FromTopPage>
  );
}

export default FAQ;
